import { differenceInDays } from "date-fns";

import { layout as layoutGuest } from "./Guest";
import { layout as layoutCharge } from "./Charge";
import { layout as layoutOccupancy } from "./Occupancy";
import UpdateFolio from "./UpdateFolio";
import FolioCustomToolbar from "./FolioToolbar";
import CardFolio from "apps/HotelFolio/components/CardFolio";
import { PlusCircleIcon, UsersIcon, ReceiptIcon } from "components/Icons";

function getName(record) {
  return record.booking;
}

const regStateColors = {
  pending: "bg-amber-400 border-amber-600",
  check_in: "bg-lime-400 border-lime-600",
  check_out: "bg-sky-400 border-sky-600",
};

function invisibleCheck(fieldName, record) {
  let res = false;
  const { registration_state } = record;
  if (fieldName === "check_in" && registration_state !== "pending") {
    res = true;
  } else if (fieldName === "check_out" && registration_state !== "check_in") {
    res = true;
  } else if (
    fieldName === "reverse_checkout" &&
    registration_state !== "check_out"
  ) {
    res = true;
  }
  return res;
}

function visibleUpdateFolio(fieldName, record) {
  let res = true;
  const { registration_state } = record;
  if (registration_state === "check_out") {
    res = false;
  }
  return res;
}

function accessDelete(rec) {
  if (["check_in", "check_out"].includes(rec.registration_state)) {
    return false;
  }
  return true;
}

function getNights(arrival, departure) {
  const arrival_date = arrival;
  const departure_date = departure;
  // if (typeof arrival === "string") {
  //   arrival_date = dates.getTrytonDate2Js(arrival);
  // }
  // if (typeof departure_date === "string") {
  //   departure_date = dates.getTrytonDate2Js(departure);
  // }
  return differenceInDays(departure_date, arrival_date).toDays();
}

function readOnlyGuest(record) {
  return record.registration_state !== "pending";
}

const withChangeProduct = (record, store) => {
  if (record.product) {
    const product = record.product;
    const uom = product["sale_uom."];
    let unit_price = product.sale_price_taxed;
    unit_price = parseFloat(unit_price.toString());
    store.unit_price = unit_price;
    store.uom = uom.id;
    record.unit_price = unit_price;
    record.unit_price_w_tax = record.product.sale_price_taxed;
    record.uom = uom;
  }
};

const withChangeDate = (record, store) => {
  const { arrival_date, departure_date, unit_price_w_tax } = record;
  if (arrival_date && departure_date) {
    const nights = getNights(arrival_date, departure_date);
    record.nights_quantity = nights;
    store.nights_quantity = nights;
    if (unit_price_w_tax) {
      record.total_amount = (nights * unit_price_w_tax).toFixed(2);
    }
  }
};

function readOnlyDates(record) {
  return ["chek_in", "check_out"].includes(record.registration_state);
}

function filterFolios(records, word) {
  const res = records.filter((rec) => rec["room."].rec_name.includes(word));
  return res;
}

function calculatePax(record, store) {
  const { num_children, num_adults } = record;
  const pax = num_children + num_adults;
  record.pax = pax;
  store.pax = pax;
  return record;
}

function layout(args) {
  const ctxView = {
    args: args,
    model: "hotel.folio",
    row_selectable: false,
    form_action_add: "modal",
    form_action: ["add", "edit", "delete"],
    table_action: ["edit"],
    activeSearch: true,
    form_rec_name: getName,
    target: "booking",
    autoSave: true,
    sizeModal: "h-9/10 w-4/5",
    customToolbar: FolioCustomToolbar,
    card: CardFolio,
    tags: {
      registration_state: regStateColors,
    },
    access: {
      delete: accessDelete,
    },
    filter: filterFolios,
    title: { field: "booking", component: "title" },
    reports: [
      {
        name: "hotel.folio.registration_card",
        label: "hotel.folio.registration_card.report",
        description: "hotel.folio.registration_card.report",
        send_print: true,
        // send_email: "send_email",
      },
    ],
    fields: {
      registration_card: { type: "char", readOnly: true },
      main_guest: {
        type: "many2one",
        model: "party.party",
        readOnly: true,
        searchable: true,
      },
      booking: {
        type: "many2one",
        model: "hotel.booking",
        readOnly: true,
        searchable: true,
      },
      arrival_date: {
        type: "date",
        required: true,
        withChange: withChangeDate,
        readOnly: readOnlyDates,
      },
      departure_date: {
        type: "date",
        required: true,
        withChange: withChangeDate,
        readOnly: readOnlyDates,
      },
      unit_price: {
        type: "numeric",
        required: true,
        decimalPlaces: 2,
        readOnly: {
          registration_state: ["check_out", "check_in"],
        },
      },
      pending_total: { type: "numeric", readOnly: true },
      nights_quantity: { type: "numeric", readOnly: true },
      room: {
        type: "many2one",
        model: "hotel.room",
        required: true,
        recSearch: () => [],
        readOnly: {
          registration_state: ["check_out", "check_in"],
        },
      },
      product: {
        type: "many2one",
        model: "product.product",
        recSearch: () => [["kind", "=", "accommodation"]],
        required: true,
        readOnly: {
          registration_state: ["check_in", "check_out"],
        },
        withChange: withChangeProduct,
        attrs: [
          "id",
          "list_price",
          "name",
          "sale_price_taxed",
          "sale_uom.rec_name",
        ],
      },
      channel: {
        type: "many2one",
        model: "hotel.channel",
        readOnly: true,
        images: { targetField: "code", source: {} },
      },
      registration_state: {
        type: "char",
        readOnly: true,
        translate: true,
        default: "pending",
      },
      number: {
        type: "char",
        readOnly: true,
      },
      meal_plan: {
        type: "many2one",
        readOnly: true,
        translate: true,
      },
      party_holder: {
        type: "many2one",
        readOnly: true,
        // translate: true,
        // searchable: true,
      },
      unit_price_w_tax: {
        type: "numeric",
        decimalPlaces: 0,
        // readOnly: true,
      },
      guests: {
        type: "one2many",
        model: "hotel.folio.guest",
        layout: layoutGuest(),
        readOnly: {
          registration_state: ["check_out"],
        },
      },
      charges: {
        type: "one2many",
        model: "hotel.folio.charge",
        layout: layoutCharge(),
        readOnly: (record) => {
          return record.registration_state === "check_out";
        },
      },
      occupancy: {
        type: "one2many",
        model: "hotel.folio.occupancy",
        layout: layoutOccupancy(),
        readOnly: {
          registration_state: ["check_out"],
        },
      },
      total_amount: { type: "numeric", readOnly: true },
      notes: {
        type: "text",
        readOnly: false,
      },
      num_adults: {
        type: "integer",
        readOnly: readOnlyGuest,
        withChange: calculatePax,
        default: 0,
      },
      num_children: {
        type: "integer",
        readOnly: readOnlyGuest,
        withChange: calculatePax,
        default: 0,
      },
      pax: {
        type: "integer",
        readOnly: true,
        default: 0,
      },
      vehicle_plate: {
        type: "char",
        searchable: true,
      },
      group: {
        type: "boolean",
        readOnly: true,
        translate: true,
      },
      payment_status: {
        type: "char",
        readOnly: true,
        translate: true,
        depends: ["charges"],
      },
      check_in: {
        type: "button",
        button_method: "check_in",
        invisible: invisibleCheck,
        onSuccessMsg: "Check In exitoso!",
        color: "blue",
      },
      check_out: {
        type: "button",
        button_method: "check_out",
        invisible: invisibleCheck,
        onSuccessMsg: "Check In exitoso!",
        color: "green",
      },
      reverse_checkout: {
        type: "button",
        button_method: "check_in",
        invisible: invisibleCheck,
        onSuccessMsg: "Check Out exitoso!",
        color: "slate",
      },
      load_accommodation: {
        type: "button",
        button_method: "load_accommodation",
        onSuccessMsg: "Tarifas cargadas!",
        icon: <PlusCircleIcon className="h-8 w-8 fill-current" />,

        color: "black",
      },
      update_folio: {
        type: "button_wizard",
        Component: UpdateFolio,
        color: "blue",
        visible: visibleUpdateFolio,
        resetWizard: false,
      },
    },
    cards: [
      { name: "room" },
      { name: "product" },
      { name: "arrival_date" },
      { name: "departure_date" },
      { name: "pax" },
      { name: "unit_price_w_tax" },
      { name: "booking" },
      { name: "nights_quantity" },
      { name: "registration_state" },
    ],
    list: [
      { name: "number", width: "10%" },
      { name: "room", width: "10%" },
      { name: "product", width: "15%" },
      { name: "party_holder", width: "15%" },
      { name: "arrival_date", width: "10%" },
      { name: "departure_date", width: "10%" },
      { name: "nights_quantity", width: "10%" },
      { name: "unit_price", width: "10%" },
      { name: "pax", width: "5%" },
      { name: "main_guest", width: "10%" },
      { name: "vehicle_plate", width: "10%" },
      { name: "registration_state", width: "10%" },
    ],
    form: [
      {
        type: "panel",
        name: "panelLeft",
        width: "w-2/3",
        elements: [
          { name: "product" },
          {
            type: "grid",
            name: "booking",
            elements: [{ name: "booking" }, { name: "number" }],
            colSpan: "col-span-1",
            // cols: "grid-cols-2",
          },
          { name: "room" },
          { name: "party_holder" },
          { name: "main_guest" },
          { name: "channel" },
          {
            type: "grid",
            name: "dates",
            elements: [{ name: "arrival_date" }, { name: "departure_date" }],
            colSpan: "col-span-1",
            // cols: "grid-cols-2",
          },
          {
            type: "grid",
            name: "nights",
            elements: [{ name: "nights_quantity" }, { name: "pax" }],
            colSpan: "col-span-1",
            // cols: "grid-cols-2",
          },
          {
            type: "grid",
            name: "pax",
            elements: [{ name: "num_adults" }, { name: "num_children" }],
            colSpan: "col-span-1",
            // cols: "grid-cols-2",
          },
          { name: "meal_plan" },
          {
            type: "grid",
            name: "prices",
            elements: [
              { name: "unit_price" },
              { name: "unit_price_w_tax" },
              { name: "pending_total" },
              { name: "total_amount" },
            ],
            // colSpan: "col-span-2",
          },
          {
            name: "states",
            type: "grid",
            elements: [
              { name: "vehicle_plate" },
              { name: "payment_status" },
              { name: "registration_state" },
            ],
            colSpan: "col-span-2",
          },
          { name: "notes" },
          {
            name: "check_buttons",
            type: "grid",
            elements: [
              { name: "check_in" },
              { name: "check_out" },
              { name: "reverse_checkout" },
            ],
            colSpan: "col-span-1",
          },
          // {
          //   name: "load_accommodation",
          //   type: "grid",
          //   elements: [{ name: "load_accommodation" }, { name: "update_folio" }],
          //   colSpan: "col-span-3",
          // },
        ],
      },
      {
        type: "panel",
        name: "panelRight",
        style: "w-full pr-3",
        elements: [
          {
            name: "charges",
            colSpan: "col-span-2",
            height: "h-3/5",
          },
          {
            name: "guests",
            widget: "cards",
            colSpan: "col-span-2",
            height: "h-2/5",
          },
        ],
      },
    ],
  };
  return ctxView;
}

export { layout };
